import { render, staticRenderFns } from "./case.vue?vue&type=template&id=c61a9b6c&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=c61a9b6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61a9b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c61a9b6c')) {
      api.createRecord('c61a9b6c', component.options)
    } else {
      api.reload('c61a9b6c', component.options)
    }
    module.hot.accept("./case.vue?vue&type=template&id=c61a9b6c&scoped=true&", function () {
      api.rerender('c61a9b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case.vue"
export default component.exports